__turbopack_context__.v({
  "avatar": "RealImpactStories-module-scss-module__iDKIuq__avatar",
  "avatarWrapper": "RealImpactStories-module-scss-module__iDKIuq__avatarWrapper",
  "body": "RealImpactStories-module-scss-module__iDKIuq__body",
  "capIcon": "RealImpactStories-module-scss-module__iDKIuq__capIcon",
  "card": "RealImpactStories-module-scss-module__iDKIuq__card",
  "carouselWrapper": "RealImpactStories-module-scss-module__iDKIuq__carouselWrapper",
  "carouselWrapperInitial": "RealImpactStories-module-scss-module__iDKIuq__carouselWrapperInitial",
  "companyLogoImg": "RealImpactStories-module-scss-module__iDKIuq__companyLogoImg",
  "companyLogoText": "RealImpactStories-module-scss-module__iDKIuq__companyLogoText",
  "container": "RealImpactStories-module-scss-module__iDKIuq__container",
  "footer": "RealImpactStories-module-scss-module__iDKIuq__footer",
  "headerRow": "RealImpactStories-module-scss-module__iDKIuq__headerRow",
  "heading": "RealImpactStories-module-scss-module__iDKIuq__heading",
  "name": "RealImpactStories-module-scss-module__iDKIuq__name",
  "navButton": "RealImpactStories-module-scss-module__iDKIuq__navButton",
  "pagination": "RealImpactStories-module-scss-module__iDKIuq__pagination",
  "paginationRow": "RealImpactStories-module-scss-module__iDKIuq__paginationRow",
  "quote": "RealImpactStories-module-scss-module__iDKIuq__quote",
  "role": "RealImpactStories-module-scss-module__iDKIuq__role",
  "swiper": "RealImpactStories-module-scss-module__iDKIuq__swiper",
});
